var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('a-icon',{attrs:{"type":"loading"}}):_vm._e(),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.error)?_c('a-tooltip',{attrs:{"title":"error"}},[_c('a-icon',{attrs:{"type":"exclamation-circle","theme":"twoTone","two-tone-color":"red"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }